import { useCallback } from 'react';
import { useEmbeddedEffect } from '@machinemetrics/mm-react-embeddable';
import { throwCriticalErrorToast } from 'lib/utils/toast';

const RUN_DETAILS_EMBED = 'apm-opdash-run-details';

// The run details embed sends a message that says what went wrong and what to
// do next, so it gets the long-lived toast rather than the 3s one.
const useRunDetailsFailureToast = (event, fallback) => {
  useEmbeddedEffect(
    RUN_DETAILS_EMBED,
    `${RUN_DETAILS_EMBED}:${event}`,
    useCallback(
      (data) => {
        throwCriticalErrorToast(data?.message || fallback);
      },
      [fallback]
    )
  );
};

const useRunDetailsFailureToasts = () => {
  useRunDetailsFailureToast('void-failed', 'Failed to delete intervals');
  useRunDetailsFailureToast('ignore-failed', 'Failed to ignore program');
  useRunDetailsFailureToast('pull-failed', 'Failed to pull job');
  useRunDetailsFailureToast('split-failed', 'Failed to split production run');
};

export default useRunDetailsFailureToasts;
